import {Page} from "@/libwyze-shared/types";
import React, {ReactElement} from "react";
import {Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinLargeButton} from "@/checkin-shared/Components";
import {CheckinScreenType, CheckinState} from "./CheckinPlayerPreviewFragment";
import {ArrowForwardOutlined} from "@mui/icons-material";
import {PAGE_FRAGMENT_WIDTH, PD_MD, PD_XLG} from "@/shared/dimens";

export function WelcomeScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void
}): ReactElement {
  const basicInfo = props.practicePage.practicePageProfile.basicInfo;
  return <>
    <StyledBoxColumn style={{alignItems: "center", gap: PD_XLG}}>
      <img src={props.practicePage.practicePageProfile.basicInfo.logo} style={{height: 72}}/>
      <Typography variant="h4" style={{marginLeft: PD_MD, fontWeight: "normal"}}>
        👋 Welcome to {basicInfo.name}
      </Typography>
      <Typography style={{lineHeight: .9, letterSpacing: -4, fontSize: "600%", fontWeight: 900}}>
        Check-in Here
      </Typography>
    </StyledBoxColumn>
    {/*<Typography variant="h4">{this.props.practicePage.practicePageProfile.address.getAddress()}</Typography>*/}
    <StyledSpan/>
    <StyledBoxRow style={{width: "100%", justifyContent: "center"}}>
      <CheckinLargeButton
        className={"attract-pulse"}
        endIcon={<ArrowForwardOutlined style={{fontSize: "125%"}}/>}
        style={{flexGrow: 1, flexBasis: 0, maxWidth: PAGE_FRAGMENT_WIDTH}}
        onClick={() => {
          props.pushScreenType(CheckinScreenType.CHOOSE_VISIT_TYPE);
        }}>
        Tap to Check-in
      </CheckinLargeButton>
      {/*<CheckinLargeButton*/}
      {/*  style={{flexGrow: 1, flexBasis: 0}}*/}
      {/*  onClick={() => {*/}
      {/*    props.setCheckinState({...props.checkinState, type: CheckinType.REGISTER});*/}
      {/*    props.pushScreenType(CheckinScreenType.REGISTER_FORM);*/}
      {/*  }}>*/}
      {/*  Register*/}
      {/*</CheckinLargeButton>*/}
      {/*<CheckinLargeButton*/}
      {/*  style={{flexGrow: 1, flexBasis: 0}}*/}
      {/*  onClick={() => {*/}
      {/*    props.setCheckinState({...props.checkinState, type: CheckinType.CHECKIN});*/}
      {/*    props.pushScreenType(CheckinScreenType.CHECKIN_QRCODE);*/}
      {/*  }}>*/}
      {/*  Check in*/}
      {/*</CheckinLargeButton>*/}
    </StyledBoxRow>
  </>;
}